import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import {
    SettingType, CodeBlock, BlockType, ValidationMessage, ValidationMessageType,
} from '@appblocks/codegeneration/types';

export default class LinkedSetting extends BaseFeature {
    constructor() {
        super();
        this.name = 'Linked Setting';
        this.id = 'linked_setting';
        this.singleInstance = false;
        this.settings = this.settings.concat([
            {
                id: 'SETTINGID',
                name: 'Setting ID',
                settingType: SettingType.OPTION,
                required: true,
                default: '',
            },
            {
                id: 'LINKEDSETTING',
                name: 'Linked Setting',
                settingType: SettingType.STRING,
                required: true,
                default: '',
            },
            {
                id: 'FEATURE',
                name: 'Feature ID',
                settingType: SettingType.STRING,
                required: true,
                default: '',
            },
        ]);
    }

    validate(): Array<ValidationMessage> {
        const errors: Array<ValidationMessage> = [];
        const project = this.project;
        let found = false;
        const LINKEDSETTING = this.getSettingValue('LINKEDSETTING');
        const SETTINGID = this.getSettingValue('SETTINGID');
        const FEATUREID = this.getSettingValue('FEATURE');
        const FEATURE = project.getFeature(FEATUREID);
        let SETTING_NAME = '';
        try {
            SETTING_NAME = project.getSetting(FEATURE.id, SETTINGID).name;
        } catch (error) {
            SETTING_NAME = 'parameter';
        }
        try {
            const enabled = project.getFeature('stg').getEnabled();
            if (enabled) {
                const settings = project.getFeature('stg').getSettingValue('SETTINGS');
                for (let i = 0; i < settings.length; i += 1) {
                    const setting = settings[i];
                    if (setting.getID() === LINKEDSETTING) {
                        const defaultValue = FEATURE.getSettingValue(SETTINGID, true);
                        if (setting.getSetting('DEFAULT').value !== defaultValue) {
                            errors.push({
                                messageType: ValidationMessageType.UPDATE,
                                message: '',
                                featureId: setting.getID(),
                                settingId: 'DEFAULT',
                                data: defaultValue,
                            });
                        }
                        found = true;
                        break;
                    }
                }
            }
        } catch (ex) {
            // not found or no setting enabled
        }
        return errors;
    }
}
